import React from 'react'
import { Box, Checkbox, Stack, Typography } from '@mui/material'
import { useGlobalState } from 'state'
import { grey } from '@mui/material/colors'
import { LAYERS } from 'common/layers'

export const HinanAreaControl = () => {
  const state = useGlobalState()
  const { estimatedFloodingLayers, setEstimatedFloodingLayers } = state.app

  const layerId = LAYERS.HINAN_AREA_ALL.id
  const [isLayerVisible, setIsLayerVisible] = React.useState<boolean>(estimatedFloodingLayers.includes(layerId))

  React.useEffect(() => {
    const arr = [...estimatedFloodingLayers]
    const idx = arr.indexOf(layerId)
    if (arr.indexOf(layerId) >= 0 && !isLayerVisible) {
      arr.splice(idx, 1)
    } else if (arr.indexOf(layerId) < 0 && isLayerVisible) {
      arr.push(layerId)
    }
    setEstimatedFloodingLayers(arr)
  }, [isLayerVisible])

  React.useEffect(() => {
    state.map.setLayoutVisibility(layerId, estimatedFloodingLayers.includes(layerId))
  }, [estimatedFloodingLayers])

  return (
    <Stack direction={'row'} spacing={1} height={40} alignItems={'center'}>
      <Checkbox size='small' sx={{p: 0, mr: 1}} checked={isLayerVisible} onChange={(e) => setIsLayerVisible(e.target.checked)} />
      <Box sx={{ width: '20px', height: '1px', borderBottom: '3px dotted #2196f3' }}></Box>
      <Typography color={grey[700]} fontSize={11} fontWeight={'bold'}>地区境</Typography>
    </Stack>
  )
}
